import { Setting2 } from "iconsax-reactjs";
import { FC, memo } from "react";
import { toggleUIModal } from "@/store/features/ui/slice";
import { ModalContent } from "@/store/features/ui/types";
import { useAppDispatch } from "@/store/hooks";
import { ToggleButton } from "@/ui";

const SettingsToggleButton: FC = () => {
  const dispatch = useAppDispatch();

  const toggle = async () => {
    dispatch(
      toggleUIModal({
        modal: ModalContent.settings
      }),
    );
  };

  return (
    <ToggleButton onClick={toggle}>
      <Setting2 />
    </ToggleButton>
  );
};

export default memo(SettingsToggleButton);
